module.exports = __webpack_public_path__ + "static/media/sv.f70893d6.webp";